<template>
  <v-card
    v-if="hasUser || loading || error"
    class="mt-4"
  >
    <v-card-title class="toolbar grey darken-1 white--text title">
      <v-icon
        dark
        color="white"
        class="mr-2"
      >
        person
      </v-icon>
      Blockchain User: {{ userId }}
      <v-spacer />
      <v-chip
        v-if="hasUser"
        dark
        small
        :color="getColorByStatus(user.status)"
      >
        {{ user.status }}
      </v-chip>
    </v-card-title>
    <v-progress-linear
      v-if="loading"
      :indeterminate="true"
      class="ma-0"
    />
    <v-card-text v-if="error">
      <v-text-field
        label="Error"
        :value="error"
        readonly
        hide-details
        color="error"
      />
    </v-card-text>
    <v-card-text v-if="hasUser">
      <v-layout
        wrap
        class="pa-0"
      >
        <v-flex
          xs12
          sm6
          md3
          class="pa-2"
        >
          <v-text-field
            label="User ID"
            :value="user.userId"
            readonly
            hide-details
          />
        </v-flex>
        <v-flex
          xs12
          sm6
          md3
          class="pa-2"
        >
          <v-text-field
            label="Created At"
            :value="userCreatedAt"
            readonly
            hide-details
          />
        </v-flex>
        <v-flex
          xs12
          sm6
          md3
          class="pa-2"
        >
          <v-text-field
            label="Updated At"
            :value="userUpdatedAt"
            readonly
            hide-details
          />
        </v-flex>
        <v-flex
          v-if="user.errorDetails"
          xs12
          sm6
          md3
          class="pa-2"
        >
          <v-text-field
            label="Error Details"
            :value="user.errorDetails"
            readonly
            hide-details
          />
        </v-flex>
      </v-layout>
      <v-layout class="mt-3">
        <v-btn
          small
          color="warning"
          :disabled="user.status !== 'error'"
          :loading="requeueLoading"
          @click="requeue"
        >
          <v-icon
            small
            class="mr-1"
          >
            restart_alt
          </v-icon>
          Requeue User
        </v-btn>
      </v-layout>
    </v-card-text>
    <v-card-text v-else-if="!loading && !error">
      <span class="grey--text">No blockchain user found for this wallet.</span>
    </v-card-text>
    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :timeout="5000"
    >
      {{ snackbar.message }}
      <v-btn
        dark
        flat
        @click="snackbar.show = false"
      >
        Close
      </v-btn>
    </v-snackbar>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'UserDetailCard',
  props: {
    userId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      requeueLoading: false,
      user: null,
      error: null,
      snackbar: {
        show: false,
        message: '',
        color: 'success',
      },
    };
  },
  computed: {
    hasUser() {
      return this.user && this.user.status;
    },
    userCreatedAt() {
      const ts = this.user && (this.user.createdAt || this.user.created);

      return ts ? this.formatDate(ts) : '-';
    },
    userUpdatedAt() {
      const ts = this.user && (this.user.updatedAt || this.user.updated);

      return ts ? this.formatDate(ts) : '-';
    },
  },
  async mounted() {
    await this.fetchUser();
  },
  methods: {
    ...mapActions([
      'getVaultUser',
      'requeueVaultUser',
    ]),
    async fetchUser() {
      this.loading = true;
      this.error = null;
      try {
        this.user = await this.getVaultUser(this.userId);
      } catch (err) {
        const msg = (err.response && err.response.data && err.response.data.message) || err.message;
        this.error = msg || 'Failed to load user';
      }
      this.loading = false;
    },
    async requeue() {
      this.requeueLoading = true;
      try {
        this.user = await this.requeueVaultUser(this.userId);
        this.snackbar = { show: true, message: 'User requeued successfully', color: 'success' };
      } catch (err) {
        this.snackbar = {
          show: true,
          message: `Failed to requeue user: ${(err.response && err.response.data && err.response.data.message) || err.message}`,
          color: 'error',
        };
      }
      this.requeueLoading = false;
    },
    formatDate(date) {
      // Handle unix timestamps in seconds (small numbers) vs milliseconds
      const ts = typeof date === 'number' && date < 1e12 ? date * 1000 : date;

      return this.$moment(new Date(ts)).format('MMMM Do YYYY, h:mm:ss a');
    },
    getColorByStatus(status) {
      if (status === 'created') { return 'success'; }
      if (status === 'queued') { return 'accent'; }
      if (status === 'error') { return 'error'; }

      return 'info';
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/shared/vault/UserDetailCard.vue